import { Colors } from "../constants/colors";
import { getRGBColorByHex } from "../services/colorsService";

export default {
  red: {
    backgroundColor: getRGBColorByHex(Colors.RED100, 0.2),
    color: Colors.RED600
  },
  green: {
    backgroundColor: getRGBColorByHex(Colors.GREEN100, 0.2),
    color: Colors.GREEN600
  },
  blue: {
    backgroundColor: getRGBColorByHex(Colors.BLUE200, 0.2),
    color: Colors.BLUE400
  },
  maroon: {
    backgroundColor: getRGBColorByHex(Colors.MAROON100, 0.2),
    color: Colors.MAROON200
  },
  orange: {
    backgroundColor: getRGBColorByHex(Colors.ORANGE100, 0.2),
    color: Colors.ORANGE300
  },
  purple: {
    backgroundColor: getRGBColorByHex(Colors.PURPLE100, 0.2),
    color: Colors.PURPLE200
  },
  grey: {
    backgroundColor: getRGBColorByHex(Colors.GREY300, 0.2),
    color: Colors.GREY400
  },
  teal: {
    backgroundColor: getRGBColorByHex(Colors.TEAL100, 0.2),
    color: Colors.TEAL300
  },
};
